import { validatePlanetbToken } from '@/api/planetb'

import { EnrollmentForm } from '../types/enrollmentForm'
import { PlanetbEnrollmentResult } from '../types/planetb'
import { applyPlanetbPrefill, mapPlanetbPayloadToFormValues } from './planetbMapper'

type TranslateFn = (key: string) => string

export function removeJwtFromUrl(): void {
  const params = new URLSearchParams(window.location.search)
  if (!params.has('jwt')) return

  params.delete('jwt')
  const search = params.toString()
  const newUrl = `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`
  window.history.replaceState({}, '', newUrl)
}

function buildErrorResult(message: string): PlanetbEnrollmentResult {
  return {
    status: 'error',
    errorMessage: message,
    prefilledFields: []
  }
}

export async function usePlanetbEnrollment(
  token: string,
  form: EnrollmentForm,
  translate: TranslateFn
): Promise<PlanetbEnrollmentResult> {
  if (!token.trim()) {
    return buildErrorResult(translate('enrollment.prefill.error'))
  }

  try {
    const payload = await validatePlanetbToken(token)
    const values = mapPlanetbPayloadToFormValues(payload)
    const prefilledFields = applyPlanetbPrefill(form, values)

    return {
      status: 'success',
      errorMessage: null,
      prefilledFields
    }
  } catch {
    return buildErrorResult(translate('enrollment.prefill.error'))
  }
}
